/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import {
    func, object, string, bool, oneOfType,
} from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import { CheckCircle } from '@material-ui/icons';
import {
    Grid, Typography,
} from '@material-ui/core';
import { uid } from 'react-uid';
import CYOBandItem from './CYOBandItem';

const useStyles = makeStyles(({ palette, breakpoints, spacing }) => ({
    cyoGroup: {
        margin: 'auto',
        width: '100%',
        padding: '16px 4px',
        [breakpoints.down('md')]: {
            maxWidth: '770px',
            width: 'min(770px, 100%)',
            padding: `${spacing(3)}px ${spacing(1)}px`,
        },
    },
    bandSelectedContainer: (bandSelected) => ({
        display: 'flex',
        flexFlow: 'row nowrap',
        padding: bandSelected ? `${spacing(2)}px` : `0px ${spacing(2)}px`,
        boxSizing: 'border-box',
        alignItems: 'center',
        overflow: 'hidden',
        transition: 'all 0.5s',
        height: bandSelected ? '55px' : '0px',
    }),
    titleContainer: {
        maxWidth: 'fit-content',
    },
    title: {
        paddingBottom: '10px',
        fontSize: '24px',
        marginLeft: spacing(2),
    },
    check: {
        fill: palette?.success?.main || '#00C876',
        marginRight: spacing(2),
        width: '35px',
        height: '35px',
    },
    selectText: {
        color: palette?.success?.main || '#00C876',
        fontWeight: '600',
    },
    itemsContainer: {
        '@media (max-width: 700px)': {
            justifyContent: 'center',
        },
    },
}));

const CYOBandGroup = React.forwardRef(({
    groupData,
    selectionError,
    clearError,
    handleSelectBand,
    handleRemoveBand,
    selectedBandID,
}, ref) => {
    const classes = useStyles(!!selectedBandID);

    const renderItem = (component) => (
        <CYOBandItem
            // eslint-disable-next-line no-nested-ternary
            handleSelectBand={(itemID, productCode) => handleSelectBand(groupData.name, itemID, productCode)}
            handleRemoveBand={handleRemoveBand}
            added={selectedBandID === component.legacyId}
            error={selectionError[component.legacyId]}
            clearError={clearError}
            itemData={component}
            key={uid(component.legacyId)}
        />
    );

    return (
        <div
            className={classes.cyoGroup}
            ref={ref}
        >
            <div className={classes.titleContainer}>
                <Typography data-testid="cyoBandTitle" variant="h5" className={classes.title}>
                    Band Selection - Required
                </Typography>
                <div className={classes.bandSelectedContainer}>
                    <CheckCircle className={classes.check} />
                    <Typography className={classes.selectText} variant="subtitle1">
                        BAND SELECTED
                    </Typography>
                </div>
            </div>
            <Grid container className={classes.itemsContainer}>
                {
                    selectedBandID
                        ? groupData.components.filter((c) => c.legacyId === selectedBandID).map(renderItem)
                        : groupData.components.map(renderItem)

                }
            </Grid>
        </div>
    );
});

CYOBandGroup.propTypes = {
    groupData: object.isRequired,
    selectionError: object.isRequired,
    clearError: func.isRequired,
    handleSelectBand: func.isRequired,
    handleRemoveBand: func.isRequired,
    selectedBandID: oneOfType([string, bool]),
};

CYOBandGroup.defaultProps = {
    selectedBandID: false,
};

export default CYOBandGroup;
